import React from 'react';
import { motion } from 'motion/react';
import { Cookie, Settings, Info, ShieldCheck } from 'lucide-react';
import Seo from '../components/Seo';
import { PAGE_METADATA, getCookiesStructuredData } from '../seo/pageMetadata';

const CookiePolicy = () => {
  return (
    <>
      <Seo {...PAGE_METADATA.cookies} structuredData={getCookiesStructuredData()} />
      <div className="pt-32 pb-24">
      <section className="px-6 max-w-4xl mx-auto">
        <motion.div 
          initial={{ opacity: 0, y: 20 }} 
          animate={{ opacity: 1, y: 0 }}
          className="mb-16 text-center"
        >
          <div className="inline-flex items-center gap-2 bg-amber-50 border border-amber-200 px-4 py-2 rounded-full mb-6">
            <Cookie className="w-4 h-4 text-royal-purple" />
            <span className="text-royal-purple text-[10px] font-black uppercase tracking-[0.2em]">Cookie Usage</span>
          </div>
          <h1 className="text-5xl md:text-6xl font-display font-black text-royal-dark tracking-tighter mb-6">
            Cookie <span className="text-royal-purple">Policy</span>
          </h1>
          <p className="text-lg text-slate-500 font-medium">
            Last Updated: April 2026
          </p>
        </motion.div>

        <div className="prose prose-slate max-w-none space-y-12">
          <section>
            <h2 className="text-3xl font-display font-black text-royal-dark mb-6 flex items-center gap-3">
              <Info className="w-8 h-8 text-royal-purple" />
              1. What are Cookies?
            </h2>
            <p className="text-slate-600 leading-relaxed text-lg font-medium">
              Cookies are small text files that are placed on your computer or mobile device when you visit a website. They are widely used to make websites work more efficiently and to provide information to the owners of the site.
            </p>
          </section>

          <section>
            <h2 className="text-3xl font-display font-black text-royal-dark mb-6 flex items-center gap-3">
              <ShieldCheck className="w-8 h-8 text-royal-purple" />
              2. How We Use Cookies
            </h2>
            <p className="text-slate-600 leading-relaxed text-lg font-medium">
              We use cookies to:
            </p>
            <ul className="list-disc pl-6 space-y-3 text-slate-600 font-medium">
              <li>Understand and save user's preferences for future visits.</li>
              <li>Compile aggregate data about site traffic and site interactions to offer better site experiences and tools in the future.</li>
              <li>Ensure the security of our website.</li>
            </ul>
          </section>

          <section>
            <h2 className="text-3xl font-display font-black text-royal-dark mb-6 flex items-center gap-3">
              <Settings className="w-8 h-8 text-royal-purple" />
              3. Managing Cookies
            </h2>
            <p className="text-slate-600 leading-relaxed text-lg font-medium">
              Most web browsers allow some control of most cookies through the browser settings. To find out more about cookies, including how to see what cookies have been set and how to manage and delete them, visit <a href="https://www.aboutcookies.org" className="text-royal-purple underline">www.aboutcookies.org</a>.
            </p>
          </section>

          <section className="bg-slate-50 p-10 rounded-[3rem] border border-slate-100">
            <h2 className="text-2xl font-display font-black text-royal-dark mb-4">Consent</h2>
            <p className="text-slate-600 font-medium leading-relaxed">
              By continuing to use our website, you consent to our use of cookies as described in this policy.
            </p>
          </section>
        </div>
      </section>
      </div>
    </>
  );
};

export default CookiePolicy;
